module.exports = __webpack_public_path__ + "img/PuckbyQrespi-poster_bg.ec99d6c3.jpg";